import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

export default function Header(){
    return (
        <header className="site-header">
            <div className="site-header-inner">
                <Link to="/" className="site-name">Ian Whitesel</Link>
                <nav className="site-nav">
                    <NavLink to="/" end>Home</NavLink>
                    <NavLink to="/projects">Side Projects</NavLink>
                    <NavLink to="/resume">Resume</NavLink>
                    <NavLink to="/contact">Contact</NavLink>
                </nav>
            </div>
        </header>
    )
}
